import styled from 'styled-components';

export const StyledUserCreateSuccess = styled.div`
  font-family: ${(props): string => props.theme.fonts.body};
  font-size: ${(props): string => props.theme.fontSizes.pageDescription};
  color: ${(props): string => props.theme.colors.text};
  min-height: inherit;

  .ant-result-success {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .user-create-success__login-em-btn {
    padding: 11px !important;
  }
`;
